import actions from "../../constants/actions";

const initialState = {
    locale: null,
    region: null,
    isCookiesVisible: true,
    isNewsletterVisible: false,
    isSplashVisible: true,
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case actions.CHANGE_SPLASH:
            return {
                ...state,
                isSplashVisible: action.payload.value,
            };
        case actions.CHANGE_LOCALE:
            return {
                ...state,
                locale: action.payload.locale,
            };
        case actions.CHANGE_REGION:
            return {
                ...state,
                region: action.payload.region,
            };
        case actions.CHANGE_COOKIES:
            return {
                ...state,
                isCookiesVisible: action.payload.value,
            };
        case actions.CHANGE_NEWSLETTER:
            return {
                ...state,
                isNewsletterVisible: action.payload.value,
            };
        default:
            return state;
    }
}
